// import parseEnvVars from 'dotenv-parse-variables';

export const env = import.meta.env as Readonly<Record<string, string>>;
